const airlineCodes = {
    aeromexico: 'AM',
    airCanada: 'AC',
    latam: 'LA',
    virginAustralia: 'VA',
};

export default airlineCodes;
